<template>
  <div>
    <MainNavBar />
    <Hero :hero="heroRecovery" />
    <Section :content="disasterRecovery" />
    <Section :content="designManagement" />
    <Section :content="costEstimating" />
    <!--Section :content="insuranceClaimReview" /-->
    <Section :content="whyUs" />
    <Section :content="streamlinedDigitalCollab" />
    <Section :content="build" />
    <Section :content="expediting" />
    <Section :content="collaboration" />
    <!--call-to-action-aconex-register /-->
    <GmxFooter />
  </div>
</template>

<script>
// @ is an alias to /src
require('@/assets/css/styles.css');
import MainNavBar from '@/components/main-nav-bar.vue';
import Hero from '@/components/hero.vue';
import Section from '@/components/section.vue';
import CallToAction from '@/components/call-to-action.vue';
import GmxFooter from '@/components/footer.vue';
import CallToActionAconexRegister from '../components/call-to-action-aconex-register.vue';
export default {
  name: 'Recovery',
  components: {
    MainNavBar,
    Hero,
    Section,
    CallToAction,
    GmxFooter,
    CallToActionAconexRegister
  },
  data() {
    return { 
      heroRecovery: { 
        eyebrowIcon: '',
        eyebrowTitle: '',
        eyebrowSubtitle: '',
        header: 'Accelerating the disaster recovery process',
        subheader: 'We take the stress out of recovery by managing every detail of your rebuild, allowing you to focus on what matters most. Our streamlined process ensures faster recovery, with expert guidance and real-time transparency through our Graphmetrix TrinPod\u2122 platform. Backed by experienced professionals, we’re here to help you rebuild with confidence and peace of mind.',
        html: '',
        //img: 'construction-team-planning-stockcake.png',
        img: 'recovery-hero.png',
        videoId: '',
        buttons: [
          { label: 'RECOVERY PATH', path: '', id: 'recovery-path' },
          { label: 'DESIGN', path: '', id: 'design' },
          { label: 'FINANCING', path: '', id: 'financing' },
          { label: 'WHY US', path: '', id: 'why-us' },
          { label: 'ACCELERATE', path: '', id: 'accelerate' },
          { label: 'BUILD', path: '', id: 'build' },
          { label: 'EXPEDITING', path: '', id: 'expediting' },
          { label: 'COLLABORATION', path: '', id: 'collaboration' },
          { label: 'TEAM', path: '', id: '' },
        ]
      },
      disasterRecovery: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Guiding Homeowners Through Recovery',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Provide end-to-end guidance for homeowners navigating the complex recovery process after natural disasters or emergencies.</li>' + 
          '<li>Act as the primary point of contact for coordinating efforts between homeowners, contractors, insurance companies, and municipal agencies.</li>' + 
          '<li>Identify potential roadblocks and proactively implement solutions to expedite recovery timelines.</li>' + 
          '</ul></div>',
        id: 'recovery-path',
        image: 'recovery-flowchart.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      designManagement: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Tailored Design Solutions for Every Need',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Oversee the development of design plans tailored to homeowners\' recovery needs, ensuring plans align with budget, regulatory requirements, and aesthetic preferences.</li>' + 
          '<li>Coordinate communication between architects, engineers, and homeowners to ensure clear understanding and efficient decision-making.</li>' + 
          '<li>Manage revisions and updates to designs as necessary to address unforeseen challenges or changes in homeowner requirements.</li>' + 
          '</ul></div>',
        id: 'design',
        //image: '003B8C8D-EDCF-4B95-A7C7-E357F2E3ABFA-crop.png',
        image: 'istockphoto-1944772735-612x612.jpg',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      costEstimating: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Cost Estimating',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Provide accurate and transparent cost estimates for construction projects, offering homeowners clarity on financial implications.</li>' + 
          '<li>Utilize advanced estimating tools and industry benchmarks to ensure competitive and fair pricing.</li>' + 
          '<li>Regularly update estimates based on project developments, ensuring homeowners are informed of any changes.</li>' + 
          '</ul></div>' + 
          '<h1 class="mb-4">Insurance Claim Review and Adjustment Management</h1>' + 
          '<div class="lead"><ul>' +
          '<li>Work together with homeowners\' and selected adjusters to review insurance policies and claims to ensure accurate coverage and maximize benefits.</li>' +
          '<li>Act as an advocate for homeowners during claim adjustments, providing guidance, maximizing your returns on contents utilizing our proven method of recovery to achieve fair settlements.</li>' + 
          '<li>Provide documentation and expert assessments to support claims and address discrepancies.</li>',
        id: 'financing',
        image: '62e1c62c5fd2c17eb5d916780369edbd.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      /*insuranceClaimReview: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Maximizing Your Insurance Benefits',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Work together with homeowners\' and selected adjusters to review insurance policies and claims to ensure accurate coverage and maximize benefits.</li>' + 
          '<li>Act as an advocate for homeowners during claim adjustments, providing guidance and helping to negotiate with insurers to achieve fair settlements.</li>' + 
          '<li>Provide documentation and expert assessments to support claims and address discrepancies.</li>' + 
          '</ul></div>',
        id: 'maximizing-insurance-benefits',
        image: 'who-does-an-independent-agent-work-for-facebook.jpg',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },*/
      whyUs: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Why Us',
        paragraphs: [
          'Our experts will help you navigate the complexities of the recovery process and provide you with real-time visibility and access to the progress of your recovery journey. Our streamlined process accelerates recovery timelines by partnering with qualified contractors, architects, and expeditors for speedy recovery.'
        ],
        /*html: '<div class="lead"><ul>' + 
          '<li>Peace of Mind<br>Recovering from the loss of your home is both emotionally and physically exhausting. At gMx, we prioritize your well-being by taking the burden of day-to-day management and oversight off your shoulders. Our experienced team handles every detail, ensuring you can focus on healing and spending time with your family while we manage the recovery process on your behalf.</li>' + 
          '<li>Speed to Recovery<br>We understand the urgency of rebuilding and restoring your life. Our streamlined process accelerates recovery timelines by partnering with qualified contractors, architects, and expeditors. With continual oversight, we address challenges proactively, ensuring your project progresses smoothly and efficiently. Our goal is to bring closure to this chapter as quickly as possible without compromising quality.</li>' + 
          '<li>Transparency<br>Trust is built on transparency, and we believe you should always have access to the progress of your recovery journey. Through our cutting-edge Graphmetrix Trinpod platform, you\'ll have real-time visibility into every stage of the process. From project milestones to pending decisions, you\'ll have the information you need at your fingertips to stay informed and confident in the progress.</li>' + 
          '<li>Expert Advice<br>Navigating the complexities of the recovery process can be overwhelming, especially when it comes to making critical decisions. Our team of experts is here to guide you every step of the way, offering clear, actionable advice tailored to your unique circumstances. From design choices to budget considerations, you\'ll have a trusted advisor to help you make informed decisions with confidence</li>' +
          '</ul></div>',*/
        id: 'why-us',
        image: 'who-does-an-independent-agent-work-for.jpg',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
        //learnMoreLink: '/recovery/why-us',
      },
      streamlinedDigitalCollab: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Streamlined Digital Collaboration',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Leverage virtual and digital tools to streamline the design process, allowing for remote collaboration and visualization.</li>' + 
          '<li>Create and share 3D models, renderings, and simulations to help homeowners make informed decisions.</li>' + 
          '<li>Coordinate virtual meetings with design teams to accelerate project timelines and minimize delays.</li>' + 
          '</ul></div>',
        id: 'accelerate',
        image: 'industrial_design_engineering_arch_rendering.png',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      build: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Ensuring Design Excellence',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Select and manage architects and engineers to ensure they meet project requirements and deadlines.</li>' + 
          '<li>Facilitate collaboration between design professionals to optimize project outcomes and reduce errors.</li>' + 
          '<li>Monitor performance and provide feedback to ensure adherence to project goals and homeowner expectations.</li>' + 
          '</ul></div>',
        id: 'build',
        image: 'code reviews for contractors 960x360.jpg',
        colOrderText: 1,
        colOrderImage: 2,
        bgClass: 'bg-light-grad',
      },
      expediting: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'Navigating Regulatory Requirements',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Work with design consultants to ensure all designs comply with local building codes, zoning laws, and regulatory requirements.</li>' + 
          '<li>Act as a liaison between homeowners and municipal agencies to expedite permit approvals and inspections.</li>' + 
          '<li>Address and resolve issues arising during the review process to prevent delays.</li>' + 
          '</ul></div>',
        id: 'expediting',
        image: 'shutterstock_444101470.jpg',
        colOrderText: 2,
        colOrderImage: 1,
        bgClass: 'bg-neon-blue-grad',
      },
      collaboration: {
        eyebrow: '',
        eyebrowIcon: '',
        headline: 'The Building Knowledge Accelerator',
        paragraphs: [],
        html: '<div class="lead"><ul>' + 
          '<li>Provides a secure supply-chain collaboration platform for storing all project-related information, including contracts, permits, designs, and communication records.</li>' + 
              '<li>Ensures homeowners have easy access to critical information at every stage of the recovery process.</li>' +
	      '<li>Digital twin technology enables future home automation and control.</li>' +
          '<li>Implements robust organizational systems to prevent information loss and facilitate efficient retrieval.</li>' + 
          '</ul></div>',
        id: 'collaboration',
        image: 'wips-to-cde.png',
        colOrderText: 1,
        colOrderImage: 2,
          bgClass: 'bg-light-grad',
	  learnMoreLink: '/trinpod-server',
      },
      aconexRegisterCTA: {
        header: 'Try It Now',
        bgClass: 'bg-neon-blue-grad',
        btnText: "Get started - it's free",
        btnVariant: 'turquoise'
      }
    }
  }
};
</script>
